import { Menu } from "lucide-preact";

export interface HeaderProps {
  online: boolean;
  /** Opens the settings drawer. Always available (post-PR #69) — the
   *  drawer's ranking knobs work pre-consent; only the privacy
   *  sections gate on personalization. */
  onOpenSettings?: () => void;
}

export function Header({ online, onOpenSettings }: HeaderProps) {
  return (
    <header class="app-header">
      {onOpenSettings ? (
        <button class="menu-btn" aria-label="Open menu" onClick={onOpenSettings}>
          <Menu size={20} aria-hidden="true" />
        </button>
      ) : (
        <span class="menu-btn" aria-hidden="true">
          <Menu size={20} />
        </span>
      )}
      <h1>Punch List</h1>
      <span class={`status ${online ? "online" : "offline"}`}>
        {online ? "online" : "offline"}
      </span>
    </header>
  );
}
